import { render, staticRenderFns } from "./HomeMoreCollections.vue?vue&type=template&id=5b056b62&scoped=true"
import script from "./HomeMoreCollections.vue?vue&type=script&lang=js"
export * from "./HomeMoreCollections.vue?vue&type=script&lang=js"
import style0 from "./HomeMoreCollections.vue?vue&type=style&index=0&id=5b056b62&prod&scoped=true&lang=css"
import style1 from "./HomeMoreCollections.vue?vue&type=style&index=1&id=5b056b62&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b056b62",
  null
  
)

export default component.exports